import React, {useEffect} from "react";
import $ from "jquery";
import FormBuilder from "../../../class/tool/FormBuilder";
import StoreSettingController from "../../../stories/_setting/StoreSettings/StoreSettingController";
import "../../../css/form/Form.css";

const StoreBillFormSheet = props => {
    const { values, errors, handleChange, handleSave } = props;
    const rows = StoreSettingController.getRows("bill");

    const buildRow = row => {
        return FormBuilder.buildInputByType(row, values, errors, change);
    }
    const change = (attribute, returnType, val, strict = false) => {
        switch (attribute) {
            case "typeDepositPurchaseOrder":
                if (val === "none")
                    val = null;
                break;
            case "valueDepositPurchaseOrder":
                switch (values.typeDepositPurchaseOrder) {
                    case "devise":
                        try {
                            val = val.replace(',','.').replace(/[^0-9.-]/g, '');

                            if (val.length === 0)
                                val = "";

                            if (val.length > 0) {
                                if (val[val.length-1] === ".") {
                                    if (val.substring(0, val.length-1).includes("."))
                                        val = val.substring(0, val.length-1);
                                }

                                if (val.includes(".")) {
                                    const expl = val.split(".");
                                    if (expl[1].length > 2)
                                        val = expl[0] + "." + expl[1].substring(0,2);
                                }
                            }
                        }
                        catch (e) {}

                        break;
                    case "percent":
                        try {
                            val = val.replace(/[^0-9]/g, '');

                            if (val.length === 0)
                                val = "";
                            else if (val.length > 3)
                                val = val.substring(0,3);

                            if (val.length > 0) {
                                if (parseInt(val) > 100)
                                    $(".inputText.valueDepositPurchaseOrder").addClass("wrong");
                                else
                                    $(".inputText.valueDepositPurchaseOrder").removeClass("wrong");
                            }
                        }
                        catch (e) {}

                        break;
                    default:
                        if (val.length > 0) {
                            val = "";
                            animTypeDepositPurchaseOrder();
                        }

                        break;
                }
                break;
            default: break;
        }

        handleChange(rows, attribute, returnType, val, strict);

        switch (attribute) {
            case "valueDepositPurchaseOrder":

                break;
            default: break;
        }
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();

        handleSave();
    }
    const animTypeDepositPurchaseOrder = () => {
        const elmt = $(".inputText.typeDepositPurchaseOrder");

        if (elmt.length === 0)
            return;

        elmt.addClass("wizz");
        setTimeout(() => { elmt.removeClass("wizz"); }, 250);
    }

    useEffect(() => {
        $("#formSettings").animate({ scrollTop: 0 }, 0);
    }, []);

    return (
        <form id={"formSettings"} className={"form inOverbox"} onSubmit={ handleSubmit } >
            {
                rows.map((row, index) => (
                    <div key={ index } className="row">
                        { (row.noLabel === undefined || !row.noLabel) && <label className={ row.classnameLabel }>{ row.label }</label> }
                        { buildRow(row) }
                    </div>
                ))
            }
        </form>
    )
}

export default StoreBillFormSheet;
